export default "__VITE_ASSET__C2zUx3gC__"